import React from 'react'

const MoveToNextRoundTemplate = ({ data }) => {
  const {
    studentName = '',
    companyName = '',
    roleName = '',
    signatureName = 'John Doe',
    signatureRole = 'Placement Coordinator',
    signatureInstitute = 'ABC Engineering College',
    signatureContact = '+91 9876543210'
  } = data

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      
      <p style={{paddingTop:'8px'}}>Dear {studentName},</p>
      
      <p style={{paddingTop:'8px'}}>
        We are pleased to inform you that your application for the role of {roleName} at {companyName} has progressed to the evaluation process stage.
      </p>
      
      <p style={{paddingTop:'10px', paddingBottom:'2px', margin:'0px'}}>Best Regards,</p>
      <p style={{paddingTop:'2px', paddingBottom:'2px', margin:'0px'}}>{signatureName}</p>
      <p style={{paddingTop:'2px', paddingBottom:'2px', margin:'0px'}}>{signatureRole}</p>
      <p style={{paddingTop:'2px', paddingBottom:'2px', margin:'0px'}}>{signatureInstitute}</p>
      <p style={{paddingTop:'2px', paddingBottom:'2px', margin:'0px'}}>{signatureContact}</p>
    </div>
  )
}

export default MoveToNextRoundTemplate
